declare namespace $ {

	type $mol_button_minor__hint_bog_mol_app_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_mol_app_2 = $mol_type_enforce<
		ReturnType< $bog_mol_app['reset'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_mol_app_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_text__text_bog_mol_app_4 = $mol_type_enforce<
		ReturnType< $bog_mol_app['digest'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_mol_app_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_32 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_35 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_38 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_39 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_41 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_44 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_45 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_48 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_expander__title_bog_mol_app_50 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_52 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_53 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_54 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_55 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_56 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_57 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_58 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_59 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_60 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_61 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_62 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_63 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_64 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_65 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_66 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_67 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_68 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_69 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_expander__title_bog_mol_app_70 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_71 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_72 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_73 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_74 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_75 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_76 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_77 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_78 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_79 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_80 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_81 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_82 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_83 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_84 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_85 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_86 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_87 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_88 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_89 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_expander__title_bog_mol_app_90 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_91 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_92 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_93 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_94 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_95 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_96 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_97 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_98 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_99 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_100 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_expander__title_bog_mol_app_101 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_102 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_103 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_104 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_105 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_106 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_107 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_108 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_expander__title_bog_mol_app_109 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_110 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_text__text_bog_mol_app_111 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_expander__title_bog_mol_app_112 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_113 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_expander__title_bog_mol_app_114 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__content_bog_mol_app_115 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_list__rows_bog_mol_app_116 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_page__title_bog_mol_app_117 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_bog_mol_app_118 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_bog_mol_app_119 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $bog_mol_app extends $giper_bot {
		reset( next?: any ): any
		Reset_icon( ): $mol_icon_trash_can_outline
		Reset( ): $mol_button_minor
		Lights( ): $mol_lights_toggle
		digest( next?: string ): string
		Digest( ): $mol_text
		Faq_start_text( ): $mol_text
		Faq_start( ): $mol_expander
		Faq_npm_text( ): $mol_text
		Faq_npm( ): $mol_expander
		Faq_local_text( ): $mol_text
		Faq_local( ): $mol_expander
		Faq_cdn_text( ): $mol_text
		Faq_cdn( ): $mol_expander
		Faq_forms_text( ): $mol_text
		Faq_forms( ): $mol_expander
		Faq_tables_text( ): $mol_text
		Faq_tables( ): $mol_expander
		Faq_reuse_text( ): $mol_text
		Faq_reuse( ): $mol_expander
		Faq_custom_text( ): $mol_text
		Faq_custom( ): $mol_expander
		Faq_css_text( ): $mol_text
		Faq_css( ): $mol_expander
		Faq_zip_text( ): $mol_text
		Faq_zip( ): $mol_expander
		Faq_seo_text( ): $mol_text
		Faq_seo( ): $mol_expander
		Faq_builds_text( ): $mol_text
		Faq_builds( ): $mol_expander
		Faq_template_text( ): $mol_text
		Faq_template( ): $mol_expander
		Faq_colors_text( ): $mol_text
		Faq_colors( ): $mol_expander
		Faq_versioning_text( ): $mol_text
		Faq_versioning( ): $mol_expander
		Faq_section_chat( ): $mol_expander
		Faq_setup_text( ): $mol_text
		Faq_setup( ): $mol_expander
		Faq_structure_text( ): $mol_text
		Faq_structure( ): $mol_expander
		Faq_viewtree_text( ): $mol_text
		Faq_viewtree( ): $mol_expander
		Faq_reactivity_text( ): $mol_text
		Faq_reactivity( ): $mol_expander
		Faq_components_text( ): $mol_text
		Faq_components( ): $mol_expander
		Faq_differences_text( ): $mol_text
		Faq_differences( ): $mol_expander
		Faq_section_quickstart( ): $mol_expander
		Faq_giper_what_text( ): $mol_text
		Faq_giper_what( ): $mol_expander
		Faq_giper_arch_text( ): $mol_text
		Faq_giper_arch( ): $mol_expander
		Faq_giper_auth_text( ): $mol_text
		Faq_giper_auth( ): $mol_expander
		Faq_giper_roles_text( ): $mol_text
		Faq_giper_roles( ): $mol_expander
		Faq_giper_crud_text( ): $mol_text
		Faq_giper_crud( ): $mol_expander
		Faq_giper_sync_text( ): $mol_text
		Faq_giper_sync( ): $mol_expander
		Faq_section_giper( ): $mol_expander
		Faq_admin_arch_text( ): $mol_text
		Faq_admin_arch( ): $mol_expander
		Faq_admin_roles_text( ): $mol_text
		Faq_admin_roles( ): $mol_expander
		Faq_admin_entity_text( ): $mol_text
		Faq_admin_entity( ): $mol_expander
		Faq_section_admin( ): $mol_expander
		Faq_tauri_setup_text( ): $mol_text
		Faq_tauri_setup( ): $mol_expander
		Faq_tauri_build_text( ): $mol_text
		Faq_tauri_build( ): $mol_expander
		Faq_section_tauri( ): $mol_expander
		Faq_docs_text( ): $mol_text
		Faq_docs( ): $mol_expander
		Faq_section_docs( ): $mol_expander
		Faq( ): $mol_list
		dialog_title( next?: string ): string
		Context( ): $mol_page
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map